{
  "id": "jewelryBox",
  "name": "Jewelry Box",
  "builds": "product",
  "category": "fineGoods",
  "note": "Thin stock and light brads. No hurry.",
  "skill": "boxJoinery",
  "duration": 45,
  "offeredBy": "bench",
  "fastener": "nails",
  "value": 18,
  "widthIn": 12,
  "heightIn": 6,
  "slots": [
    {
      "id": "slat-0",
      "role": "slat",
      "part": {
        "widthIn": 3,
        "lengthIn": 12,
        "thicknessQ": 2
      },
      "stock": {
        "type": "board",
        "species": "realWood",
        "surface": "sanded"
      },
      "xIn": 6,
      "yIn": 1.5,
      "angleDeg": 90,
      "zIn": 0
    },
    {
      "id": "slat-1",
      "role": "slat",
      "part": {
        "widthIn": 3,
        "lengthIn": 12,
        "thicknessQ": 2
      },
      "stock": {
        "type": "board",
        "species": "realWood",
        "surface": "sanded"
      },
      "xIn": 6,
      "yIn": 4.5,
      "angleDeg": 90,
      "zIn": 0
    },
    {
      "id": "wall-0",
      "role": "wall",
      "part": {
        "widthIn": 2,
        "lengthIn": 12,
        "thicknessQ": 2
      },
      "stock": {
        "type": "board",
        "species": "realWood",
        "surface": "sanded"
      },
      "xIn": 6,
      "yIn": 0.5,
      "angleDeg": 90,
      "zIn": 0.5,
      "onEdge": true
    },
    {
      "id": "wall-1",
      "role": "wall",
      "part": {
        "widthIn": 2,
        "lengthIn": 12,
        "thicknessQ": 2
      },
      "stock": {
        "type": "board",
        "species": "realWood",
        "surface": "sanded"
      },
      "xIn": 6,
      "yIn": 5.5,
      "angleDeg": 90,
      "zIn": 0.5,
      "onEdge": true
    },
    {
      "id": "end-0",
      "role": "end",
      "part": {
        "widthIn": 2,
        "lengthIn": 6,
        "thicknessQ": 2
      },
      "stock": {
        "type": "board",
        "species": "realWood",
        "surface": "sanded"
      },
      "xIn": 0.5,
      "yIn": 3,
      "angleDeg": 0,
      "zIn": 2.5,
      "onEdge": true
    },
    {
      "id": "end-1",
      "role": "end",
      "part": {
        "widthIn": 2,
        "lengthIn": 6,
        "thicknessQ": 2
      },
      "stock": {
        "type": "board",
        "species": "realWood",
        "surface": "sanded"
      },
      "xIn": 11.5,
      "yIn": 3,
      "angleDeg": 0,
      "zIn": 2.5,
      "onEdge": true
    },
    {
      "id": "divider-0",
      "role": "divider",
      "part": {
        "widthIn": 2,
        "lengthIn": 6,
        "thicknessQ": 2
      },
      "stock": {
        "type": "board",
        "species": "realWood",
        "surface": "sanded"
      },
      "xIn": 4,
      "yIn": 3,
      "angleDeg": 0,
      "zIn": 2.5,
      "onEdge": true
    }
  ],
  "fasteners": [
    {
      "xIn": 6,
      "yIn": 0.5
    },
    {
      "xIn": 6,
      "yIn": 5.5
    },
    {
      "xIn": 0.5,
      "yIn": 0.5
    },
    {
      "xIn": 11.5,
      "yIn": 0.5
    },
    {
      "xIn": 4,
      "yIn": 0.5
    },
    {
      "xIn": 0.5,
      "yIn": 5.5
    },
    {
      "xIn": 11.5,
      "yIn": 5.5
    },
    {
      "xIn": 4,
      "yIn": 5.5
    }
  ]
}
